/**
 * @file axios.js
 * @brief Builds authenticated Axios clients for the frontend API.
 */
import axios from "axios";

/**
 * Create an Axios instance that automatically attaches the current bearer token.
 * @param {Object} auth Authentication state from the OIDC context or a compatible snapshot.
 * @returns {import("axios").AxiosInstance} Configured API client.
 */
export const createApiClient = (auth) => {
    const api = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL + "/api/v1",
    });

    api.interceptors.request.use((config) => {
        if (auth?.isAuthenticated) {
            config.headers["Authorization"] = `Bearer ${auth.user?.access_token}`;
        }
        return config;
    });

    return api;
};

export const getApiAuthSnapshot = (auth) => ({
    isAuthenticated: Boolean(auth?.isAuthenticated),
    user: auth?.user
        ? { access_token: auth.user.access_token }
        : null,
});